import { render, staticRenderFns } from "./EquipmentIndex.vue?vue&type=template&id=6b83963a&"
import script from "./EquipmentIndex.vue?vue&type=script&lang=js&"
export * from "./EquipmentIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports